import React from 'react'

import { getRichText } from '../../core'
import MediaWithContent from '../MediaWithContent'

import './map.scss'

class MapSection extends React.Component {
  constructor(props) {
    super(props)
    this.mapRef = React.createRef()
  }

  componentDidMount() {
    const data = this.props.data || {}
    const mapCenter =  data.mapCenter || {
      // DEFAULT IS BOND HQ!
      lat: 40.7068263,
      lon: -74.01303039999999,
    }              

    if (
      typeof window === 'undefined'
      || !window.mapboxgl
      || !mapCenter
    ) {
      return
    }

    const { lat, lon } = mapCenter
    const mapboxgl = window.mapboxgl
    mapboxgl.accessToken = 'pk.eyJ1IjoiYm9uZGNvbGxlY3RpdmUiLCJhIjoiY2p0N2t3d3lkMHQ0YzQzcHQ3c2FuYXc1OCJ9.FcOEYN71iYJljZ0gMs6RHw'

    this.map = new mapboxgl.Map({
      container: this.mapRef.current,
      style: 'mapbox://styles/bondcollective/cjtopg51316l61fnutoicdahk',
      center: [ lon, lat ],
      zoom: 14,
    });

    this.mapMarker = new mapboxgl.Marker()
      .setLngLat([ lon, lat ])
      .addTo(this.map);

    this.map.scrollZoom.disable();
    this.map.addControl(new mapboxgl.NavigationControl());
  }

  render() {
    const data = this.props.data || {}
    const context = this.props.context || {}

    const { 
      content,
      contentTheme,
      isFullHeight,
    } = data

    const { 
      locationPDF,
    } = context

    return (
      <MediaWithContent
        media={(
          <div styleName="map" ref={this.mapRef}></div>
        )}
        content = {(
          <div styleName="content">
            <div styleName="inner">
              {getRichText(content)}

              {locationPDF && 
                <a 
                  styleName='location-pdf-link' 
                  href={locationPDF.file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download a Location Summary
                </a>
              }
            </div>
          </div>
        )}
        contentTheme={contentTheme}
        isFullHeight={isFullHeight}
      />
    )
  }
}

export default MapSection